import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {gsap} from "gsap";
import {KennethMustDie} from "../../KennethMustDie";
import {KMDGameMode} from "../../server/KMDGameMode";
import {KMDGameAssets} from "../../KMDGameAssets";
import {KMDSound} from "../../sound/KMDSound";

export class KMDFSOutro extends PIXI.Container implements StageLayer {

    private _item: PIXI.spine.Spine;
    private _amount: PIXI.BitmapText;
    private _button: ContinueButton;
    private _clickCallback: () => void;

    constructor() {
        super();
        this.name = "KMDFSOutro";

        this.init();
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    public showOutro(callback: () => void): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.3
            }),
            isBelowWinStake: boolean = KennethMustDie.apiPlugin.gameClientConfiguration.belowStakeWinRestriction,
            totalWin: number = KennethMustDie.model.gameData.accumulatedRoundWin,
            playedBetValue: number = KennethMustDie.model.gameData.playedBetValue;

        tl.add(() => {
            this._item.visible = true;
            this._item.updateTransform();

            this._item.state.clearTracks();
            this._item.skeleton.setToSetupPose();
            this._item.skeleton.setSlotsToSetupPose();
            this._item.state.setEmptyAnimation(0, 0);

            KennethMustDie.blackBg.show(0.8);

            this._amount.text = totalWin.toFixed(2);
            this._amount.fontSize = 40;
            while (this._amount.textWidth > 280) {
                this._amount.fontSize--;
            }
            this._amount.visible = true;

            this._clickCallback = callback;

            this.playOutroSound();
        });
        tl.add(KennethMustDie.createTimelineForAnimation(this._item, 0, this.getAnimationTabName(isBelowWinStake, totalWin, playedBetValue), false));

        // #525
        if (KennethMustDie.model.gameData.wasFeatureBuy && KennethMustDie.autoPlayPlugin.isAutoplayRound) {
            tl.to(this, {
                duration: 0.3
            });
            tl.add(() => {
                this.onButtonClick();
            });
        } else {
            tl.add(() => {
                this._button.alpha = 0;
                this._button.visible = true;
            });
            tl.to(this._button, {
                duration: 0.5,
                alpha: 1
            }, "<");
            tl.add(() => {
                this._button.enable(true);
            });
        }
    }

    protected getAssetName(): string {
        return ("fsOutro");
    }

    protected getAnimationTabName(isBelowWinStake: boolean, totalWin: number, playedBetValue: number): string {
        return "animation";
    }

    protected playOutroSound(): void {
        KennethMustDie.soundPlayer.playSound(KMDSound.CFS_INTRO_IMPACT); // #504

        KennethMustDie.soundPlayer.switchMusic("fsIntro");
    }

    protected playBtnSound(): void {
        KennethMustDie.soundPlayer.playSound(KMDSound.BTN_OUTRO_FS);
    }

    private init(): void {
        this._item = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset(this.getAssetName()));
        this._item.position.set(360);
        this._item.visible = false;

        this._amount = new PIXI.BitmapText("", {
            fontSize: 40,
            fontName: KMDGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            align: "center"
        });
        this._amount.visible = false;
        this._amount.position.set(360, 280);
        this._amount.anchor = new PIXI.Point(0.5);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => {
            this.onButtonClick();

            // #409
            this.playBtnSound();
        });
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false);
        this._button.visible = false;
        this.onResize();

        this.addChild(this._item, this._amount, this._button);
    }

    private onButtonClick(): void {
        KennethMustDie.backgroundElements.setMode(KMDGameMode.NORMAL);

        this._button.enable(false);
        const tl: gsap.core.Timeline = gsap.timeline(),
            duration: number = 0.5;

        tl.add(KennethMustDie.returnToMainGame(duration), 0);
        tl.to([this._button, this._amount, this._item], {
            duration: duration,
            alpha: 0
        }, 0);

        tl.add(() => {
            this._button.visible = false;
            this._item.visible = this._amount.visible = false;
            this._item.alpha = this._amount.alpha = 1;

            this._clickCallback();
        });
    }
}